module.exports = __webpack_public_path__ + "static/media/February2022Newsletter.4aa1a163.pdf";